<template>
  <div>
    <h1>Chart Sandbox</h1>
    <p>Dev env only sandbox to view chart behaviour</p>
    <v-container>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="chartsWidth"
            label="Charts Width (vw)"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="chartsHeight"
            label="Charts Height (px)"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="chartsType"
            label="Chart Type"
            :items="registryOptions"
            item-title="label"
            item-value="key"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
    <v-card v-if="chartsType" style="overflow-y: auto; height: 80vh">
      <div v-for="i in reportThemes.length" :key="i">
        <div v-for="(item, j) in reportThemes[i - 1].config" :key="j">
          <div v-if="item.chartType" :id="j.toString()">
            <!-- Charts -->
            <Charts
              v-if="
                item.chartType === activeLabel ||
                reportThemes[i - 1].name === 'Aus Pyramid' ||
                (item.chartType === 'Pyramid' &&
                  reportThemes[i - 1].name === 'Population sample')
              "
              :key="`${chartsType}-${item.chartRef}`"
              :load="true"
              :item="item"
              :indicatorValues="indicatorValues"
              :comparators="comparatorAreaCodes"
              :comparatorsList="comparatorsList"
              :reportThemeObject="reportThemes[i - 1]"
              :chartWidthProp="chartsWidth + 'vw'"
              :chartHeight="chartsHeight + 'px'"
            />
          </div>
        </div>
      </div>
    </v-card>
    <v-card></v-card>
  </div>
</template>

<script>
import Charts from "@/components/Charts";
import {
  getEntry as getMockEntry,
  registryOptions,
} from "@/mocks/chart-sandbox/registry.js";

export default {
  name: "ChartSandbox",
  data: () => ({
    chartsWidth: 75,
    chartsHeight: 500,
    chartsType: null,
    // Registry-driven state (populated by watcher)
    reportThemes: [],
    indicatorValues: {},
    comparatorsList: [],
    comparatorAreaCodes: [],
    registryOptions,
  }),
  components: { Charts },
  async mounted() {
    // Clear localStorage to force using pyramid-au
    localStorage.removeItem("sandbox.chartType");

    const saved = localStorage.getItem("sandbox.chartType");
    let key = null;
    if (saved) {
      if (getMockEntry(saved)) {
        key = saved; // already a key
      } else {
        const opt = registryOptions.find((o) => o.label === saved);
        key = opt ? opt.key : null; // migrate old label to key
      }
    }
    this.chartsType = key || "pyramid-au";
  },
  watch: {
    chartsType: {
      handler(val) {
        // persist selection between sessions
        localStorage.setItem("sandbox.chartType", val);

        // Resolve via registry key
        const entry = getMockEntry(val);
        if (entry && entry.data) {
          const d = entry.data;

          // Ensure data is properly preserved
          this.reportThemes = [{ ...d.reportTheme, config: d.items }];
          this.indicatorValues = { ...d.indicatorValues };
          this.comparatorsList = [...d.comparatorsList];
          this.comparatorAreaCodes = [...d.comparatorAreaCodes];
        } else {
          // Chart not found in registry - clear state
          console.warn(`Chart type "${val}" not found in registry`);
          this.reportThemes = [];
          this.indicatorValues = {};
          this.comparatorsList = [];
          this.comparatorAreaCodes = [];
        }
      },
    },
  },
  computed: {
    activeLabel() {
      const opt = registryOptions.find((o) => o.key === this.chartsType);
      return opt ? opt.label : this.chartsType;
    },
  },
  methods: {},
};
</script>

<style scoped></style>
